export const NETWORK_ERROR = "Network Error";
export const INTERNET_ERROR = "Internet Error";
